import z from 'zod'
import {
  blacklistedWords,
  passwordSpecialCharRegex,
  validPasswordSpecialChars
} from './constants'

export const includesLowerUpperAndNumeric = (str: string) => {
  return /[a-z]/.test(str) && /[A-Z]/.test(str) && /[0-9]/.test(str)
}
export const passwordSchema = z
  .string()
  .min(12)
  .max(4096)
  .refine((pswd) => {
    if (!includesLowerUpperAndNumeric(pswd)) return false

    return passwordSpecialCharRegex.test(pswd)
  })

export const confirmPasswordSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: passwordSchema
  })
  .refine(({ password, confirmPassword }) => password === confirmPassword)

export const generatePasswordRequirements = (password: string) => {
  const isValidLength = password.length >= 12
  const hasSpecialChar = passwordSpecialCharRegex.test(password)
  const hasMixedCaseAndNumber = includesLowerUpperAndNumeric(password)
  const isBlacklisted = blacklistedWords.includes(password)

  const reqs = [
    { name: 'Be at least 12 characters', isValid: isValidLength },
    {
      name: `Contain one of: ${validPasswordSpecialChars.join(' ')}`,
      isValid: hasSpecialChar
    },
    {
      name: 'Contain 1 lowercase, uppercase, and numeric character',
      isValid: hasMixedCaseAndNumber
    }
  ]

  if (isBlacklisted) {
    reqs.push({
      name: `Password contains blacklisted words: ${blacklistedWords.join(
        ', '
      )}`,
      isValid: false
    })
  }

  return reqs
}

export const redirectToAuth = (authServerUrl: string) => {
  const currentUrl = window.location.href
  const encodedRedirectUri = encodeURIComponent(currentUrl)
  window.location.href = `${authServerUrl.replace(
    '/api/',
    '/'
  )}?redirect_uri=${encodedRedirectUri}`
}
